/**
 * Application entry point that mounts the React root component,
 * registers action plugins, and imports global styles.
 */
import { registerBuiltInPlugins } from "@nucleus/action-plugins";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";


import { App } from "./App";
import "./styles/globals.css";

// Initialize action type plugins
registerBuiltInPlugins();

const rootElement = document.getElementById("root");
if (!rootElement) {
	throw new Error("Root element not found");
}

createRoot(rootElement).render(
	<StrictMode>
		<App />
	</StrictMode>
);
